import { render, staticRenderFns } from "./BpFinancialPerformanceTable.vue?vue&type=template&id=fbc5514e"
import script from "./BpFinancialPerformanceTable.vue?vue&type=script&lang=ts"
export * from "./BpFinancialPerformanceTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports